
import { useCallback } from "react";
import { InventoryItem } from "@/types/inventory";
import { 
  Table, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "@/components/ui/table";
import { LoadingState } from "./LoadingState";
import { EmptyState } from "./EmptyState";
import { InventoryTimestamp } from "./InventoryTimestamp";
import { InventoryTableBody } from "./table/InventoryTableBody";
import { sortInventoryResults } from "@/utils/inventory/sortUtils";

interface Props {
  results: InventoryItem[];
  isLoading: boolean;
  hasSearched?: boolean;
  lastUpdate?: string | null;
}

export const InventoryTableResults = ({ results, isLoading, hasSearched = false, lastUpdate }: Props) => {
  const renderContent = useCallback(() => {
    if (isLoading) {
      return <LoadingState />;
    }

    if (results.length === 0) {
      return <EmptyState hasSearched={hasSearched} />;
    }

    // Sort the results using the utility function
    const sortedResults = sortInventoryResults(results);

    return (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Product</TableHead>
            <TableHead>Artikelnr.</TableHead>
            <TableHead>Barcode</TableHead>
            <TableHead>Eenheid</TableHead>
            <TableHead>Magazijn</TableHead>
            <TableHead>Locatie</TableHead>
            <TableHead>Voorraad</TableHead>
            <TableHead>MOQ</TableHead>
            <TableHead>Acties</TableHead>
          </TableRow>
        </TableHeader>
        <InventoryTableBody results={sortedResults} />
      </Table>
    );
  }, [results, isLoading, hasSearched]);

  return (
    <div className="overflow-x-auto">
      <InventoryTimestamp lastUpdate={lastUpdate} />
      {renderContent()}
    </div>
  );
};
